import { createAsyncThunk } from '@reduxjs/toolkit';

import { selectCurrentEnvironmentName } from '../../../../environment/selectors/current-environment-name.selector.ts';
import { DefaultPathEnum } from '../../../../main/constants/default-path.ts';
import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';
import { getLessonsUtil } from '../../../../main/utils/asset/lessons.util.ts';
import { getUrlUtil } from '../../../../main/utils/url.util.ts';

import { mapIsLessonImplemented } from '../../../mappers/is-lesson-implemented.mapper.ts';
import { selectCurrentLessonTaskStepKey } from '../../../selectors/current-lesson-task-step-key.selector.ts';

import { moveToNextStep } from '../lesson.slice.ts';
import { LESSON_SLICE_NAME } from '../lesson.slice.types.ts';

import { navigateToStepThunk } from './navigate-to-step.thunk.ts';

interface Props {
  blockAnimation?: boolean;
}

const THUNK_NAME = `${LESSON_SLICE_NAME}/navigateToNextStepThunk`;

export const navigateToNextStepThunk = createAsyncThunk<void, Props | undefined, ThunkApiConfigType>(
  THUNK_NAME,
  async (props = {}, thunkAPI): Promise<void> => {
    const { blockAnimation = false } = props;

    const state = thunkAPI.getState();
    const currentLessonTaskStepKey = selectCurrentLessonTaskStepKey(state);
    const nextLessonTaskStepKey = getLessonsUtil().getNextLessonTaskKey(currentLessonTaskStepKey);

    thunkAPI.dispatch(moveToNextStep());

    const environmentName = selectCurrentEnvironmentName(state);
    if (nextLessonTaskStepKey && !mapIsLessonImplemented(nextLessonTaskStepKey.lesson, environmentName)) {
      await getUrlUtil().navigateToUrl(DefaultPathEnum.LEARN_LESSONS_COMPLETED_SCREEN);
      return;
    }

    await thunkAPI.dispatch(navigateToStepThunk({ blockAnimation })).unwrap();
  }
);
